import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import { HeadingOne } from 'Common/Custom/HeadingOne'
import LoanReportListTable from './Components/LoanReportListTable'

const LoanReportList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={<HeadingOne>Loan Report</HeadingOne>}>

            <div className="col-12">
                <LoanReportListTable />
            </div>
        </PageBody>
    )
}

export default LoanReportList
